{
	"title": "Транзакцията не е намерена",
	"description": "Моля, отидете на прегледа и въведете валиден идентификатор на транзакция. Идентификатор на транзакция може да бъде намерен в декларация или във фактура.",
	"secondaryButtonTitle": "Покажи началната страница"
}
